import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Labels } from "./PatientLabels";
import { useAlertHelpers } from "../../helper/Hooks/useAlertHelpers";

interface SessionCountsProps {
  labels: Labels;
  setLabels: (labels: Labels) => void;
}

const SessionCounts = ({ labels, setLabels }: SessionCountsProps) => {
  const { showAlertModal } = useAlertHelpers();

  // get current 'THERAPY_END_SESSION_COUNT' number
  const currentSessionCount =
    labels.find((label) => label.key === "THERAPY_END_SESSION_COUNT")?.value ||
    "";

  const handleAddSessionCount = (text) => {
    //delete this label if the input is null
    if (text === "") {
      const updatedLabels = labels.filter(
        (label) => label.key !== "THERAPY_END_SESSION_COUNT",
      );
      setLabels(updatedLabels);
      return;
    }

    //check the existence of current session count value
    const sessionCount = { key: "THERAPY_END_SESSION_COUNT", value: text };
    const countExists = labels.some(
      (label) => label.key === "THERAPY_END_SESSION_COUNT",
    );

    //update the session count number with new value
    const updatedLabels = countExists
      ? labels.map((label) =>
          label.key === "THERAPY_END_SESSION_COUNT" ? sessionCount : label,
        )
      : [...labels, sessionCount];
    setLabels(updatedLabels);
  };

  return (
    <Row className="mb-3">
      <Col>
        <Form.Group controlId="formGridCode">
          <Form.Label>Sitzungszahl bei Therapieende</Form.Label>
          <Form.Control
            className="form-control"
            type="text"
            placeholder="Sitzungszahl"
            value={currentSessionCount}
            onChange={(e) => {
              let value = e.target.value;

              //Check if the input is a valid integer
              if (value && !/^\d*$/.test(value)) {
                showAlertModal("Bitte geben Sie nur Zahlen ein.");
                value = value.replace(/[^\d]/g, ""); //remove non-numeric characters
                e.target.value = value;
              }

              handleAddSessionCount(value);
            }}
          ></Form.Control>
        </Form.Group>
      </Col>
    </Row>
  );
};

export default SessionCounts;
